<template>
  <button class="editButton" :class="{ '-active': isActive }">
    <i class="budicon-solid budicon-solid-pencil-writing"></i>
    <span>Rediger</span>
  </button>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'EditButton',
  props: {
    isActive: {
      type: Boolean,
      required: false,
    },
  },
});
</script>

<style scoped lang="scss">
.editButton {
  display: inline-flex;
  justify-content: center;
  align-items: baseline;
  padding: 4px 6px;
  border-radius: 4px;
  background: white;
  border: 1px solid $gray-200;
  box-shadow: $box-shadow-2;
  transition: $transition-base;
  cursor: pointer;

  i {
    color: $primary;
    font-size: 1.1rem;
    margin-right: 4px;
  }
  span {
    color: $primary;
  }
  &:hover {
    background-color: $primary;
    i,
    span {
      color: white;
    }
  }
}

.editButton.-active {
  background: $primary;

  i {
    color: white;
    font-size: 1.1rem;
  }
  &:hover {
    background-color: white;
    i,
    span {
      color: $primary;
    }
  }
}
</style>
